var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ies-form-field", { attrs: { field: _vm.field } }, [
    _c("textarea", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.input,
          expression: "input",
        },
      ],
      attrs: {
        id: this.field.fieldName + "_textarea",
        name: this.field.fieldName,
        type: "text",
        disabled: this.field.disabled,
      },
      domProps: { value: _vm.input },
      on: {
        keyup: function ($event) {
          return _vm.updateField()
        },
        input: function ($event) {
          if ($event.target.composing) return
          _vm.input = $event.target.value
        },
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }